import { render, staticRenderFns } from "./_base-modal-confirm.vue?vue&type=template&id=2e9049f5&scoped=true&"
import script from "./_base-modal-confirm.vue?vue&type=script&lang=js&"
export * from "./_base-modal-confirm.vue?vue&type=script&lang=js&"
import style0 from "./_base-modal-confirm.vue?vue&type=style&index=0&id=2e9049f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9049f5",
  null
  
)

export default component.exports